module.exports = __webpack_public_path__ + "static/highest-satisfaction-0da56e451d3cdffa48762114d182323c.svg";